import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="autofocus"
export default class extends Controller {
  connect() {
    setTimeout(() => {
      this.element.focus();
    }, 1);
  }
}
